// webpackにてbundle.jsにコンパイル
// import jQuery from 'jquery'
import Swiper from 'swiper' // スライダー
// import 'swiper/dist/css/swiper.min.css'   // SwiperCSS
// import slick         from 'slick-carousel'  // スライダー
// import 'slick-carousel/slick/slick.css'  // SlickメインCSS
// import 'slick-carousel/slick/slick-theme.css'  // SlickテーマCSS
import magnificPopup from 'magnific-popup' // 万能モーダル
// import baguetteBox   from 'baguettebox.js'  // 画像用簡易モーダル
// import 'baguettebox.js/dist/baguetteBox.min.css' // baguetteBoxCSS
// import lozad         from 'lozad'           // Intersection Observerによるスクロール発火（要ポリフィル）
// import YTPlayer         from 'jquery.mb.ytplayer'  // YouTube制御
// import 'jquery.mb.YTPlayer/dist/css/jquery.mb.YTPlayer.min.css'   // jquery.mb.YTPlayerCSS
// import trunk8 from 'trunk8'  // 行数制限
import jqueryZoom from 'jquery-zoom' // ホバー時画像が拡大する
// import jqueryMigrate from 'jquery-migrate'
// import jqueryCookie from 'jquery.cookie' // Cookie
import './_smoothScroll.js' // スムーズスクロール

jQuery(function ($) {

  let name = 'spmenu' // このIDを基準としたアコーディオン
  $('#' + name + '-open,#' + name + '-close,#' + name + '-overlay').on('click', function () {
    $('#' + name + ',#' + name + '-open,#' + name + '-overlay').toggleClass('active')
    $('body').toggleClass('lock')
  })

  if ($('.mv-slide.swiper-container')[0]) { // Swiperコンテナを検出したら実行
    let mySwiper = new Swiper('.swiper-container', { // eslint-disable-line
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      // loopAdditionalSlides: 10,  //ループ演出用のクローン数を増やして安定化させる
      centeredSlides: true,
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 3, // 表示数変更
      // spaceBetween: 5,   // スライド同士の間隔を空ける
      // freeMode: true,     //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
      // grabCursor: true,      // 掴みカーソル
      //    simulateTouch: false,  // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      //    autoHeight: true,      // スライドごとに高さを変動させる
      // fadeEffect: {          // フェードオプション
      //   crossFade: true      // クロスフェード
      // },
      autoplay: { // オートオプション
        delay: 7000, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      },
      pagination: { // ページャーオプション
        el: '.mv-slide.swiper-pagination', // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true // クリックでジャンプ可能にする
        // renderBullet: function (index, className) {  // bulletsの描画内容改変　画像のサムネイルにする
        //   var targetImage = $('[data-swiper-slide-index="' + index + '"]').find('img').attr('src')
        //   return '<div class="' + className + '"><img src=" ' + targetImage + ' " alt="ページ' + index + '" /></div>'
        // }
      },
      keyboard: { // キーボード操作
        enabled: true
      },
      // mousewheel: {  // マウスホイール操作
      // },
      navigation: {
        nextEl: '.mv-slide.swiper-button-next', // 前のページボタンを呼び出す要素
        prevEl: '.mv-slide.swiper-button-prev' // 次のページボタンを呼び出す要素
      },
      breakpoints: { // 指定px以下の環境時の設定
        768: {
          slidesPerView: 1 // 表示数変更
        }
      }
    })
  }

  $('.confirm-ac-menu-01').on('click', function () { //アコーディオンメニュー
    $('.confirm-ac-content-01').slideToggle();
  });

  $('.confirm-ac-menu-02').on('click', function () { //アコーディオンメニュー
    $('.confirm-ac-content-02').slideToggle();
  });

  $('.cart-in').on('click', function () { //カートボタンクリック時CSS変更
    $(this).toggleClass('active');
  });

  $('.l-cart .cart').magnificPopup({ //モーダル
    delegate: '.popup-img',
    type: 'image',
    mainClass: "img-popup-wrap"
  });

  $('.popup-container').magnificPopup({ //モーダル
    delegate: '.modal-link',
    type: 'inline',
    mainClass: "details-popup-wrap",
    gallery: {
      enabled: true,
    }
  });

  $('.l-edit').magnificPopup({ //モーダル
    delegate: '.edit-modal-link',
    type: 'inline',
    mainClass: "edit-popup-wrap"
  });

  $('.l-cart .cart-list').magnificPopup({ //モーダル
    delegate: '.cart-modal-link',
    type: 'inline',
    mainClass: "cart-popup-wrap"
  });

  $(document).on({ //ホバー時画像拡大
    'mouseenter': function () {
      $('.zoom-img').zoom({
        magnify: 3
      })
    }
  }, '.zoom-img');

  $(document).on('click', '.js-link', function (e) { //リンクを取得して飛ばす
    e.stopPropagation();
    e.preventDefault();
    open($(this).attr('data-url'), "_blank");
  });

  $(document).on('click', '.l-details .tab-list li', function () { //画像トリミング
    $('.picture-list-small .modal-link > img').each(function () {
      var imgW = $(this).width();
      var imgH = $(this).height();
      if (imgW > imgH) { //横長の画像の場合
        $(this).height('100%');
        $(this).width('auto');
      } else { //縦長の画像の場合
        $(this).width('100%');
        $(this).height('auto');
      }
    });
  });

  $(window).on('load scroll resize', function () { //固定カートボタン挙動
    var windowWidth = window.innerWidth;
    var scrollHeight = $(document).height(); //ドキュメントの高さ
    var scrollPosition = $(window).height() + $(window).scrollTop(); //現在地
    var footHeight = $('footer').innerHeight(); //footerの高さ（＝止めたい位置）
    if (scrollHeight - scrollPosition <= footHeight) { //ドキュメントの高さと現在地の差がfooterの高さ以下になったら
      $('#price-bar').css({
        'position': 'absolute',
        'bottom': -30
      });
    } else {
      $('#price-bar').css({
        'position': 'fixed',
        'bottom': 0
      });
    }
    if (windowWidth > 768) {
      if (scrollHeight - scrollPosition <= footHeight) {
        $('#cart-btn').css({
          'position': 'absolute',
          'bottom': 0
        });
      } else {
        $('#cart-btn').css({
          'position': 'fixed',
          'bottom': 30
        });
      }
    } else {
      $('#cart-btn').css({
        'position': 'initial',
        'bottom': 'initial'
      });
    }
  });

  if ($('.js-change-bg').find('option:selected').hasClass('not-select')) { //選択時CSS変更
    $('.js-change-bg').css({
      'background-color': '#f7f7f7'
    });
  }

  $('.js-change-bg').on('change', function () { //選択時CSS変更
    if ($(this).find('option:selected').hasClass('not-select')) {
      $(this).css({
        'background-color': '#f7f7f7'
      });
    } else {
      $(this).css({
        'background-color': '#fff'
      });
    }
  });

  $('#postal').jpostal({ //住所検索
    click: '#zipsearch',
    postcode: [
      '#postal'
    ],
    address: {
      '#prefectures': '%3',
      '#municipality': '%4%5'
    }
  });

  $('#field-zip').jpostal({ //住所検索
    click: '#zipsearch-address',
    postcode: [
      '#field-zip'
    ],
    address: {
      '#field-pref_id': '%3',
      '#field-address1': '%4%5'
    }
  });

  /**
   * スクロール処理
   * @param {*} point 目標地点
   * @param {*} adjust 位置をずらす場合の基準要素or基準値
   * @param {*} anime アニメーションの有無
   */
  function autoScroll(point, adjust, anime) {
    if (adjust === undefined) { //未定義なら0
      adjust = 0;
    } else if (isNaN(adjust)) { //数値以外でなら要素として高さ取得
      adjust = $(adjust).outerHeight();
    }
    var target = $((point == '#' || point === '') ?
      'html' :
      point);

    if (anime === true || anime === undefined) {
      //未定義ならアニメーションさせる
      $('html,body')
        .not(':animated')
        .animate({
          scrollTop: target
            .offset()
            .top - adjust
        }, 500, 'swing');
    } else {
      $('html,body')
        .not(':animated')
        .animate({
          scrollTop: target
            .offset()
            .top - adjust
        }, 10, 'linear');
    }
    return false;
  }
  var scrollAdjust = 98; //スムーズスクロールの補正要素
  $('a[href*="#"]').not('.no-move, [target="_blank"],.popup-img,.modal-link,.edit-modal-link,.cart-modal-link').click(function () { //アンカーをクリックしたらスクロール
    var href = $(this).attr('href').replace(/.*#/gi, '#'); //同一ページならハッシュ以外を削ってページ遷移を抑止
    autoScroll(href, scrollAdjust);
  });
  $(window).on('load', function () {
    if (location.hash)
      autoScroll(location.hash, scrollAdjust, false); //アクセス時にハッシュがある場合はスクロール
  });

  $(document).on('contextmenu', '.l-cart .cart .cart-list>li .img a', function () { //右クリック禁止
    alert('右クリックはご遠慮いただいております');
    return false;
  });

  $(document).on('contextmenu', '.img-popup-wrap', function () { //右クリック禁止
    alert('右クリックはご遠慮いただいております');
    return false;
  });

})
